<script setup>
import AppSumoRedemptionForm from '@/components/AppSumoRedemptionForm.vue'
import { onMounted, onUnmounted } from 'vue'

// Hidden-but-not-secret page: it must never be indexed. The URL is only reachable from the
// buyer's AppSumo purchase (or a discreet footer link). Security comes from single-use codes
// and rate limiting, not from the obscurity of the URL.
let metaEl = null

onMounted(() => {
  metaEl = document.createElement('meta')
  metaEl.name = 'robots'
  metaEl.content = 'noindex, nofollow'
  document.head.appendChild(metaEl)
})

onUnmounted(() => {
  if (metaEl && metaEl.parentNode) {
    metaEl.parentNode.removeChild(metaEl)
  }
})
</script>

<template>
  <div>
    <app-sumo-redemption-form />
  </div>
</template>
